<template>
  <div>
    <div class="content-title">结算规则</div>
    <div style="padding: 10px; border: 1px solid #e4d6d6; color: red; font-size: 16px;">
      <p>一、双方按合同/协议约定，甲方已知晓并确认自由职业者仅限于从事合法合规生产经营的个人，下列人员不属于自由职业者范畴（不得在结算人员范围内）：</p>
        <p>&nbsp;&nbsp;1、结算方的法定代表人、股东、董事、监事、实际控制人。</p>
        <p>&nbsp;&nbsp;2、与结算方（含关联方）具有劳动/劳务合同关系的劳动人事法律关系的人员。<p>
        <p>&nbsp;&nbsp;3、双方约定的其他不在结算范围的人员。<p>
      <p>三、结算所涉的自由职业者条件为：</p>
        <p>&nbsp;&nbsp;1、结算所涉个人的年龄范围 >= 18周岁—— &lt;= 60周岁。</p>
        <p>&nbsp;&nbsp;2、结算所涉个人月累计额＜92000元/人/月。</p>
    </div>
    <div style="padding: 20px; border: 1px solid #e4d6d6;">
      <el-button type="primary" @click="limitUserVisible = true">新增限制用户</el-button>
    </div>
    <div class="content-table">
      <el-table :data="limitusers" size='medium' tooltip-effect="dark">
        <el-table-column prop="providerName" label="公司" align="center" width="500px"></el-table-column>
        <el-table-column prop="userName" label="姓名" align="center" width="500px"></el-table-column>
        <el-table-column prop="userAccno" label="身份证号" align="center" width="500px"></el-table-column>
      </el-table>
    </div>
    <div class="content-pagination fr" v-if="total > pageSize">
      <el-pagination @current-change="handleChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
    <el-dialog title="新增转账限额用户" width="600px" :visible.sync="limitUserVisible" append-to-body>
      <el-form ref="form" :model="providerLimitUser" label-width="120px">
        <el-form-item label="用户姓名：" style="margin-bottom: 20px;">
          <el-input v-model="providerLimitUser.userName" style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="用户身份证号：" style="margin-bottom: 20px;">
          <el-input v-model="providerLimitUser.userAccno" style="width: 250px;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="confirmButton">保存</el-button>
          <el-button @click="limitUserVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api/api';

export default {
  name: 'limituser',
  data() {
    return {
      limitusers: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      limitUserVisible: false,
      providerLimitUser: {
        userName: '',
        userAccno: '',
      },
    };
  },
  mounted() {
    this.fetchLimitUsers();
  },
  methods: {
    fetchLimitUsers() {
      this.limitusers = [];
      api.fetchLimitUsers({
        params: {
          params: {
            index: this.currentPage - 1,
            size: this.pageSize,
          },
        },
      }).then((res) => {
        console.log('limitusers: ', res);
        this.limitusers = [];
        this.total = 0;
        if (!res) {
          return;
        }
        this.total = res.count;
        if (!res.data) {
          return;
        }
        this.limitusers = res.data;
      }).catch((err) => {
        console.log(err);
        this.$message({
          type: 'error',
          message: err.response.message,
        });
      });
    },
    handleChange(index) {
      this.currentPage = index;
      this.fetchLimitUsers();
    },
    confirmButton() {
      this.$confirm('新增转账限额用户：'.concat(this.providerLimitUser.userName, '，身份证号：', '', this.providerLimitUser.userAccno), {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.addLimitUser();
      });
    },
    addLimitUser() {
      api.addLimitUser({
        params: {
          data: this.providerLimitUser,
        },
      }).then(() => {
        this.$message({
          type: 'success',
          message: '新增成功',
        });
        this.limitUserVisible = false;
      }).catch((err) => {
        console.log(err);
        this.$message({
          type: 'error',
          message: err.response.message,
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>

.app-main {
  height: calc(100% - 71px);
  margin: auto;
}

.content-title {
  font-size: 18px;
  margin: 10px 20px 20px 20px;
}

.available-money-class {
  font-size: 18px;
  color: #188fff;
  margin-right: 40px;
  letter-spacing: 3px;
  font-weight: bold;
}

.content-tool {
  // padding: 27px 17px 20px 17px;
  // border: 1px solid #ebeef5;
  background: #fff;
  font-size: 15px;
  color: #606266;
  overflow: hidden;
  margin: 10px 20px 20px 20px;
  .content-tool--nav {
    display: inline-block;
    vertical-align: middle;
    width: 30%;
    padding: 0 10px;
    .content-tool--title {
      width: 56px;
      margin-right: 10px;
      height: 36px;
      line-height: 36px;
      font-size: 14px;
      text-align: right;
    }
    .content-tool--input {
      width: calc(100% - 66px);
      height: 36px;
    }
  }
}
.content-tool--operate {
    padding: 0px 17px 20px 17px;
    margin: 0px 20px 20px 20px;
  }
.content-search-title {
  .search {
    height: 80px;
    border: 1px solid #fff;
  }
  .content-table--title {
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 2px;
    color: #188fff;
    display: inline-block;
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
  }
  .search-title {
    margin: 0 50px 0 20px;
  }
}
.fr {
  float: right;
}
.fl {
  float: left;
}
.content-table {
  width: 100%;
  margin: 30px 20px;
  font-size: 15px;
  .detail-name {
    color: #20a0ff;
    cursor: pointer;
    text-decoration: underline;
  }
  .detail-name-txt {
    color: #20a0ff;
  }
}
.content-pagination {
  padding: 20px 40px 0 0;
}

.reason-content {
  margin: 10px;
  height: 40px;
  font-size: 15px;
}

.content-tip {
  color: #0779bd;
  height: 36px;
  line-height: 36px;
  margin-left: 10px;
}
</style>

<style scoped>
.el-form .el-form-item{
  margin-bottom: 0px;
}
</style>




// WEBPACK FOOTER //
// src/components/limituser.vue